import React, { useEffect, useState } from "react";
import ModalComponent from "../../../components/modals";
import LaddaButton from "../../../components/buttons/laddaButton";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Grid } from "@mui/material";
import FormTextField from "../../../components/textField/formTextField";
import {
  callActionApiAsync,
  getBiomedicalEquipmentModelSummary,
  putUpdateBiomedicalEquipmentModel
} from "../../../services/apiService";
import ToastNotification from "../../../components/toastNotification";

const validationSchema = yup.object().shape({
  name: yup.string().required("Este campo es obligatorio")
});

const EditModelModal = ({ open, close, modelRow, onSaved, userId }) => {
  const [showToast, setShowToast] = useState(false);
  const [toastConfig, setToastConfig] = useState({
    severity: "warning",
    summary: "",
    detail: ""
  });
  const [equipmentCount, setEquipmentCount] = useState(null);
  const [summaryLoading, setSummaryLoading] = useState(false);

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: { name: "" }
  });

  useEffect(() => {
    const loadSummary = async () => {
      if (!(open && modelRow?.value && userId)) return;
      setSummaryLoading(true);
      try {
        const { data } = await getBiomedicalEquipmentModelSummary(
          modelRow.value,
          userId
        );
        setEquipmentCount(
          typeof data?.equipmentCount === "number" ? data.equipmentCount : 0
        );
      } catch {
        setEquipmentCount(null);
      } finally {
        setSummaryLoading(false);
      }
    };

    if (open && modelRow) {
      reset({ name: modelRow.name || "" });
      loadSummary();
    } else if (open && !modelRow) {
      reset({ name: "" });
      setEquipmentCount(null);
    } else if (!open) {
      setEquipmentCount(null);
    }
  }, [open, modelRow, reset, userId]);

  const handleClose = () => {
    reset();
    setEquipmentCount(null);
    close();
  };

  const onSubmit = async (formData) => {
    if (!modelRow?.value) return;
    await callActionApiAsync(
      () =>
        putUpdateBiomedicalEquipmentModel({
          id: modelRow.value,
          brandId: modelRow.brandId,
          name: formData.name,
          userId
        }),
      () => {
        onSaved?.();
        handleClose();
      },
      (err) => {
        const detail =
          typeof err === "string" && err
            ? err
            : "No se pudo actualizar el modelo.";
        setToastConfig({
          severity: "error",
          summary: "Error",
          detail
        });
        setShowToast(true);
      }
    );
  };

  return (
    <>
      <ModalComponent
        open={open}
        handleClose={handleClose}
        title="Editar modelo"
        actions={<div className="HContainer j-center w-complete"></div>}
        maxWidth="640px"
      >
        <div className="HContainer">
          <form
            className="VContainer align-center m-20"
            onSubmit={handleSubmit(onSubmit)}
          >
            {!summaryLoading && equipmentCount != null && equipmentCount > 0 && (
              <div
                className="mb-15"
                style={{
                  padding: "10px 12px",
                  fontSize: "14px",
                  lineHeight: 1.45,
                  background: "#e3f2fd",
                  borderRadius: "8px",
                  border: "1px solid #90caf9",
                  maxWidth: "420px"
                }}
              >
                Este modelo está asociado a <strong>{equipmentCount}</strong>{" "}
                equipo(s) biomédico(s). El cambio de nombre se reflejará en todos
                ellos.
              </div>
            )}
            <Grid container rowSpacing={2}>
              <Grid item xs={12}>
                <p className="create-label">Nombre del modelo:</p>
                <FormTextField
                  name="name"
                  control={control}
                  error={errors.name}
                />
              </Grid>
              <Grid item xs={12} className="HContainer j-center">
                <LaddaButton type="submit" variant="contained">
                  Guardar
                </LaddaButton>
              </Grid>
            </Grid>
          </form>
        </div>
      </ModalComponent>
      <ToastNotification
        showToast={showToast}
        setShowToast={setShowToast}
        severity={toastConfig.severity}
        summary={toastConfig.summary}
        detail={toastConfig.detail}
      />
    </>
  );
};

export default EditModelModal;
